import * as React from 'react';

import { useMutation } from '@apollo/client';

import {
  WishlistMutateListsMutation,
  WishlistMutateListsMutationVariables,
} from '@notino/shared/definitions/types';

import wishlistMutateListsMutation from '@components/Universals/WishlistModifier/queries/wishlistMutateLists.graphql';

type Params = {
  missingProductIds: number[];
  listId: string;
};

export const useRemoveMissingProducts = ({
  missingProductIds,
  listId,
}: Params) => {
  const [mutateLists] = useMutation<
    WishlistMutateListsMutation,
    WishlistMutateListsMutationVariables
  >(wishlistMutateListsMutation);

  React.useEffect(() => {
    if (missingProductIds?.length > 0) {
      void mutateLists({
        variables: {
          removeFromList: [listId],
          addToList: [],
          productIds: missingProductIds.map(String),
        },
      });
    }
  }, [missingProductIds, listId, mutateLists]);
};
